<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>班级管理</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- <div class="main-box">
      <queryClassBar @queryResult="queryHandle" />
    </div> -->
    <div class="tableList">
         <el-form :inline="true" :model="formClass" label-width="90px" class="searchForm">
      <el-form-item label="班级名称:">
        <el-select
          v-model="formClass.name"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in classNameList"
            :key="index"
            :label="item.className"
            :value="item.className"
          ></el-option>
        </el-select>
        <!-- <el-input v-model="formClass.name" placeholder="输入班级名称"></el-input> -->
      </el-form-item>
      <el-form-item label="开课时间:" label-width="110px">
        <el-date-picker
          v-model="formClass.startTime"
          type="daterange"
          placeholder="开课时间"
          format="yyyy-MM-dd"
          placement="bottom-end"
          style="width:250px;font-size:10px"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
      </el-form-item>
    </el-form>
       <!-- <queryClassBar ref="classquery" @queryResult="queryHandle"  /> -->
      <div class="operBtn">
        <el-button
          type="primary"
          icon="plus"
          @click="addClass"
          style="float: right; margin-bottom: 5px"
          >建立班级</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="queryData"
         :header-cell-style="rowClass"
        v-loading.body="loading"
        tooltip-effect="dark"
        id="Table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column
          prop="classId"
          label="班级ID"
          align="center"
          width="90"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewClass(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.classId }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="班级名称"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewClass(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.name }}</a
            >
          </template>
        </el-table-column>
        <!--<el-table-column prop="level" label="级别" align="center" width="90"></el-table-column>-->
        <el-table-column
          prop="startTime"
          label="开课时间"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          label="课程进度"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.package != undefined">
              {{ scope.row.package.progress }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="personCount"
          label="学员人数"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="mainTeacher.name"
          label="老师"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="enabled"
          label="状态"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.enabled" type="success">已上架</el-tag>
            <el-tag v-else type="danger">已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          show-overflow-tooltip
          align="center"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="mini"
                @click="handleEdit(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottomOperBtn">
        <el-button
          type="danger"
          @click="delClass"
          icon="delete2"
          style="margin-top: 20px"
          >删除</el-button
        >
        <el-button
          type="primary"
          @click="shangjiaClass"
          icon="arrow-up"
          style="margin-top: 20px"
          >上架</el-button
        >
        <el-button
          type="info"
          @click="xiajiaClass"
          icon="arrow-down"
          style="margin-top: 20px"
          >下架</el-button
        >
      </div>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { compareTimeWithNow, formatDateString } from "../commonEdu";
import queryClassBar from "../componentsEdu/queryClassBar";
export default {
  name: "classList",
  data() {
    return {
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      classNameList:[],
      multipleSelection: [],
      loading: true,
      queryTerms: null,
        formClass: {
        name: "",
        level: "",
        startTime: [],
      },
    };
  },
  components: { queryClassBar },
  props: {},
  created() {
    this.fetchClassList();
    this.feachClassName()
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {
     rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    fetchClassList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
      };

      if (this.formClass.name != "") {
        params.name = this.formClass.name;
      }
        if (this.formClass.level != "") {
        params.level = this.formClass.level;
      }
       if (this.formClass.startTime&&this.formClass.startTime.length&&this.formClass.startTime.length == 2) {
          if (
           this.formClass.startTime[0] != null &&
            this.formClass.startTime[1] != null
          ) {
            params.startTime = [
              formatDateString(this.formClass.startTime[0]),
              formatDateString(this.formClass.startTime[1]),
            ];
          }
        }
      //   if (this.formClass.startTime != "") {
      //   params.id = this.formTeacher.name;
      // }
        //  console.log(this, 'thisdasd')
        //  console.log(this.$refs.classquery,'99999999999999999')
        //  console.log(this.$refs,'99999999999999999')
        //  debugger

      // if (this.queryTerms != null) {
        // var classquery = this.$refs.classquery
        
        // if (this.$refs.classquery.formClass.name != "") {
        //   params.name = this.$refs.classquery.formClass.name;
        // }
        // if (classquery.level != "") {
        //   params.level = this.$refs.classquery.formClass.level;
        // }
      //   if (this.$refs.classquery.formClass.startTime&&this.$refs.classquery.formClass.startTime.length&&this.$refs.classquery.formClass.startTime.length == 2) {
      //     if (
      //      this.$refs.classquery.formClass.startTime[0] != null &&
      //       this.$refs.classquery.formClass.startTime[1] != null
      //     ) {
      //       params.startTime = [
      //         formatDateString(this.$refs.classquery.formClass.startTime[0]),
      //         formatDateString(this.$refs.classquery.formClass.startTime[1]),
      //       ];
      //     }
      //   }
      // }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.eduAxiosPostRequest("/edu/eduAdmin/class/list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal = m.pager.total;

            for (let i in this.queryData) {
              if (this.queryData[i].package != undefined) {
                let periodTemp = "";
                if (this.queryData[i].package.period == 1) {
                  periodTemp = "日";
                } else if (this.queryData[i].package.period == 2) {
                  periodTemp = "周";
                } else if (this.queryData[i].package.period == 3) {
                  periodTemp = "月";
                }
                this.queryData[
                  i
                ].package.progress = `${this.queryData[i].package.progress}/${this.queryData[i].package.count}${periodTemp}`;
              }
            }
          }
          this.loading = false;
        }
      );
    },
     onQuery() {
       this.queryParams.page = 1
      this.fetchClassList();
    },
    addClass() {
      this.$router.push({
        name: "addClass",
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(cls) {
      this.$router.push({
        name: "addClass",
        query: {
          id: cls.classId,
        },
      });
    },
    viewClass(cls) {
      this.$router.push({
        name: "addClass",
        query: {
          id: cls.classId,
          do: "view",
        },
      });
    },
    feachClassName() {
      let params = {
        appId: this.$API.APPID,
        isAll: 1
      };
      this.$axios
        .post("/edu/eduAdmin/class/get_class_or_group_list", params)
        .then((res) => {
          if (res != null) {
            this.classNameList = res.data.data.classList;
          }
        });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchClassList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchClassList();
    },
    delClass() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择班级");
        return;
      }
      let nedConfirm = [];
      for (let i in this.multipleSelection) {
        if (
          this.multipleSelection[i].enabled &&
          !this.checkTime(this.multipleSelection[i].startTime)
        ) {
          nedConfirm.push(this.multipleSelection[i].name);
        }
      }
      let contentTemp = "<ul><li>请确认是否删除所选班级。</li>";
      if (nedConfirm.length > 0) {
        let temp = "";
        for (let i in nedConfirm) {
          temp += nedConfirm[i];
          if (i != nedConfirm.length - 1) {
            temp += "；";
          }
        }
        contentTemp += `<li>${temp}：已经上架且开班，删除后已开班的学生APP上则不再显示课程。</li>`;
      }
      contentTemp += "</ul>";

      this.$Modal.confirm({
        title: "确认删除？",
        content: contentTemp,
        onOk: () => {
          let ids = [];
          for (let i in this.multipleSelection) {
            ids.push(`${this.multipleSelection[i].classId}`);
          }
          let params = {
            appId: this.$API.APPID,
            classId: ids,
          };
          this.eduAxiosPostRequest("/edu/eduAdmin/class/delete", params).then(
            (res) => {
              if (res != null) {
                this.$Message.success("删除成功!");
                this.fetchClassList();
              }
            }
          );
        },
      });
    },
    shangjiaClass() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择班级");
        return;
      }
      let classIdList = [];
      for (let i in this.multipleSelection) {
        let name = this.multipleSelection[i].name;
        if (this.multipleSelection[i].startTime == null) {
          ApiMessage(this, `${name}：没有开班时间，不允许上架`, "error");
        } else if (this.multipleSelection[i].package == undefined) {
          ApiMessage(this, `${name}：课包为空，不允许上架`, "error");
        } else {
          classIdList.push(`${this.multipleSelection[i].classId}`);
        }
      }
      this.shangxiajiaSendServer(classIdList, true);
    },
    xiajiaClass() {
      if (this.multipleSelection.length == 0) {
        alert("请先选择班级");
        return;
      }
      let classIdList = [];
      let nedConfirm = [];
      for (let i in this.multipleSelection) {
        if (
          this.multipleSelection[i].enabled &&
          !this.checkTime(this.multipleSelection[i].startTime)
        ) {
          nedConfirm.push(this.multipleSelection[i].name);
          classIdList.push(`${this.multipleSelection[i].classId}`);
        } else if (this.multipleSelection[i].enabled) {
          classIdList.push(`${this.multipleSelection[i].classId}`);
        }
      }

      if (nedConfirm.length > 0) {
        let temp = "";
        for (let i in nedConfirm) {
          temp += nedConfirm[i];
          if (i != nedConfirm.length - 1) {
            temp += "；";
          }
        }
        this.$Modal.confirm({
          title: "确认下架？",
          content:
            temp + "：已经上架且开班，下架后已开班的学生APP上则不再显示课程。",
          onOk: () => {
            this.shangxiajiaSendServer(classIdList, false);
          },
        });
      } else {
        this.shangxiajiaSendServer(classIdList, false);
      }
    },
    shangxiajiaSendServer(classIdList, op) {
      if (classIdList.length > 0) {
        let params = {
          appId: this.$API.APPID,
          classIdList: classIdList,
          enabled: op,
        };
        this.eduAxiosPostRequest(
          "/edu/eduAdmin/class/class_batch",
          params
        ).then((res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchClassList();
          }
        });
      }
    },
    checkTime(timeCheck) {
      let time = new Date(timeCheck);
      let startTime = parseInt(time.getTime() / 1000);
      console.log(startTime);
      if (startTime == 0) {
        return true;
      }
      return compareTimeWithNow(timeCheck);
    },
    // queryHandle(param) {
    //   console.log(param);
    //    this.queryParams.page
    //   this.queryTerms = param;
       
    //   this.fetchClassList();
    // },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("delete") != -1 ||
                address.indexOf("class_batch") != -1
              ) {
                resolve(JSON.stringify(response.data));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";
.searchBox {
  background: #fff;
}
.table {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// classList.vue?1e1542f5